export interface EmojiInfo {
  char: string;
  name: string;
  keywords: string[];
}

export interface EmojiCategory {
  id: string;
  name: string;
  icon: string;
  emojis: EmojiInfo[];
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'smileys',
    name: 'Smileys & Emotion',
    icon: '😀',
    emojis: [
      { char: '😀', name: 'grinning face', keywords: ['smile', 'happy', 'grin'] },
      { char: '😃', name: 'grinning face with big eyes', keywords: ['smile', 'happy', 'joy'] },
      { char: '😄', name: 'grinning face with smiling eyes', keywords: ['smile', 'happy', 'laugh'] },
      { char: '😁', name: 'beaming face with smiling eyes', keywords: ['smile', 'grin', 'happy'] },
      { char: '😆', name: 'grinning squinting face', keywords: ['laugh', 'happy', 'haha'] },
      { char: '😅', name: 'grinning face with sweat', keywords: ['laugh', 'sweat', 'relief'] },
      { char: '🤣', name: 'rolling on the floor laughing', keywords: ['rofl', 'laugh', 'lol'] },
      { char: '😂', name: 'face with tears of joy', keywords: ['lol', 'laugh', 'tears', 'joy'] },
      { char: '🙂', name: 'slightly smiling face', keywords: ['smile', 'happy', 'slightly'] },
      { char: '🙃', name: 'upside-down face', keywords: ['silly', 'sarcasm'] },
      { char: '😉', name: 'winking face', keywords: ['wink', 'flirt'] },
      { char: '😊', name: 'smiling face with smiling eyes', keywords: ['smile', 'happy', 'warmth'] },
      { char: '😇', name: 'smiling face with halo', keywords: ['angel', 'innocent'] },
      { char: '🥰', name: 'smiling face with hearts', keywords: ['love', 'hearts', 'crush'] },
      { char: '😍', name: 'smiling face with heart-eyes', keywords: ['love', 'heart', 'adore'] },
      { char: '🤩', name: 'star-struck', keywords: ['star', 'eyes', 'excited'] },
      { char: '😘', name: 'face blowing a kiss', keywords: ['kiss', 'love', 'flirt'] },
      { char: '😗', name: 'kissing face', keywords: ['kiss'] },
      { char: '😚', name: 'kissing face with closed eyes', keywords: ['kiss'] },
      { char: '😋', name: 'face savoring food', keywords: ['yum', 'delicious', 'hungry'] },
      { char: '😛', name: 'face with tongue', keywords: ['tongue', 'playful'] },
      { char: '😜', name: 'winking face with tongue', keywords: ['wink', 'tongue', 'playful'] },
      { char: '🤪', name: 'zany face', keywords: ['crazy', 'silly'] },
      { char: '😝', name: 'squinting face with tongue', keywords: ['tongue', 'playful'] },
      { char: '🤑', name: 'money-mouth face', keywords: ['money', 'rich'] },
      { char: '🤗', name: 'hugging face', keywords: ['hug', 'warm'] },
      { char: '🤭', name: 'face with hand over mouth', keywords: ['gasp', 'oops'] },
      { char: '🤫', name: 'shushing face', keywords: ['quiet', 'shh'] },
      { char: '🤔', name: 'thinking face', keywords: ['think', 'hmmm'] },
      { char: '🤐', name: 'zipper-mouth face', keywords: ['secret', 'quiet'] },
      { char: '🤨', name: 'face with raised eyebrow', keywords: ['suspicious', 'skeptical'] },
      { char: '😐', name: 'neutral face', keywords: ['meh', 'neutral'] },
      { char: '😑', name: 'expressionless face', keywords: ['meh', 'expressionless'] },
      { char: '😶', name: 'face without mouth', keywords: ['quiet', 'mute'] },
      { char: '😏', name: 'smirking face', keywords: ['smirk', 'sly'] },
      { char: '😒', name: 'unamused face', keywords: ['meh', 'unamused'] },
      { char: '🙄', name: 'face with rolling eyes', keywords: ['eyeroll', 'whatever'] },
      { char: '😬', name: 'grimacing face', keywords: ['grimace', 'awkward'] },
      { char: '🤥', name: 'lying face', keywords: ['lie', 'pinocchio'] },
      { char: '😌', name: 'relieved face', keywords: ['relieved', 'peace'] },
      { char: '😔', name: 'pensive face', keywords: ['sad', 'pensive'] },
      { char: '😪', name: 'sleepy face', keywords: ['tired', 'sleepy'] },
      { char: '🤤', name: 'drooling face', keywords: ['drool', 'hungry'] },
      { char: '😴', name: 'sleeping face', keywords: ['sleep', 'zzz'] },
      { char: '😷', name: 'face with medical mask', keywords: ['sick', 'mask'] },
      { char: '🤒', name: 'face with thermometer', keywords: ['sick', 'fever'] },
      { char: '🤕', name: 'face with head-bandage', keywords: ['hurt', 'bandage'] },
      { char: '🤢', name: 'nauseated face', keywords: ['sick', 'nausea'] },
      { char: '🤮', name: 'face vomiting', keywords: ['vomit', 'sick'] },
      { char: '🤧', name: 'sneezing face', keywords: ['sneeze', 'cold'] },
      { char: '🥵', name: 'hot face', keywords: ['hot', 'heat'] },
      { char: '🥶', name: 'cold face', keywords: ['cold', 'freeze'] },
      { char: '🥴', name: 'woozy face', keywords: ['drunk', 'dizzy'] },
      { char: '😵', name: 'face with crossed-out eyes', keywords: ['dead', 'dizzy'] },
      { char: '🤯', name: 'exploding head', keywords: ['mindblown', 'wow'] },
      { char: '🤠', name: 'cowboy hat face', keywords: ['cowboy', 'yeehaw'] },
      { char: '🥳', name: 'party face', keywords: ['party', 'celebrate'] },
      { char: '🥸', name: 'disguised face', keywords: ['disguise', 'mask'] },
      { char: '😎', name: 'smiling face with sunglasses', keywords: ['cool', 'sunglasses'] },
      { char: '🤓', name: 'nerd face', keywords: ['nerd', 'geek'] },
      { char: '🧐', name: 'face with monocle', keywords: ['fancy', 'monocle'] },
      { char: '😕', name: 'confused face', keywords: ['confused'] },
      { char: '😟', name: 'worried face', keywords: ['worried'] },
      { char: '🙁', name: 'slightly frowning face', keywords: ['sad'] },
      { char: '😮', name: 'face with open mouth', keywords: ['gasp', 'wow'] },
      { char: '😯', name: 'hushed face', keywords: ['quiet', 'surprise'] },
      { char: '😲', name: 'astonished face', keywords: ['shock', 'wow'] },
      { char: '😳', name: 'flushed face', keywords: ['blush', 'flushed'] },
      { char: '🥺', name: 'pleading face', keywords: ['please', 'puppy', 'eyes'] },
      { char: '😦', name: 'frowning face with open mouth', keywords: ['sad', 'gasp'] },
      { char: '😧', name: 'anguished face', keywords: ['anguished', 'sad'] },
      { char: '😨', name: 'fearful face', keywords: ['fear', 'scared'] },
      { char: '😰', name: 'anxious face with sweat', keywords: ['anxious', 'sweat'] },
      { char: '😱', name: 'face screaming in fear', keywords: ['scream', 'scared'] },
      { char: '😡', name: 'pouting face', keywords: ['angry', 'mad'] },
      { char: '😠', name: 'angry face', keywords: ['angry', 'mad'] },
      { char: '🤬', name: 'face with symbols on mouth', keywords: ['swear', 'angry'] },
      { char: '😈', name: 'smiling face with horns', keywords: ['devil', 'evil'] },
      { char: '👿', name: 'angry face with horns', keywords: ['devil', 'angry'] },
      { char: '💀', name: 'skull', keywords: ['dead', 'skull', 'skeleton'] },
      { char: '☠️', name: 'skull and crossbones', keywords: ['danger', 'poison'] },
      { char: '💩', name: 'pile of poo', keywords: ['poop', 'poo'] },
      { char: '🤡', name: 'clown face', keywords: ['clown', 'funny'] },
      { char: '👹', name: 'ogre', keywords: ['monster', 'ogre'] },
      { char: '👺', name: 'goblin', keywords: ['monster', 'goblin'] },
      { char: '👻', name: 'ghost', keywords: ['ghost', 'spooky'] },
      { char: '👽', name: 'alien', keywords: ['alien', 'ufo'] },
      { char: '👾', name: 'alien monster', keywords: ['alien', 'game'] },
      { char: '🤖', name: 'robot', keywords: ['robot', 'bot'] },
      { char: '😺', name: 'grinning cat', keywords: ['cat', 'smile'] },
      { char: '😸', name: 'grinning cat with smiling eyes', keywords: ['cat', 'smile'] },
      { char: '😹', name: 'cat with tears of joy', keywords: ['cat', 'lol'] },
      { char: '😻', name: 'smiling cat with heart-eyes', keywords: ['cat', 'love'] },
      { char: '😼', name: 'cat with wry smile', keywords: ['cat', 'smirk'] },
      { char: '😽', name: 'kissing cat', keywords: ['cat', 'kiss'] },
      { char: '🙀', name: 'weary cat', keywords: ['cat', 'shock'] },
      { char: '😿', name: 'crying cat', keywords: ['cat', 'sad'] },
      { char: '😾', name: 'pouting cat', keywords: ['cat', 'angry'] },
      { char: '👋', name: 'waving hand', keywords: ['hello', 'bye', 'wave'] },
      { char: '🤚', name: 'raised back of hand', keywords: ['hand'] },
      { char: '🖐️', name: 'hand with fingers splayed', keywords: ['hand'] },
      { char: '✋', name: 'raised hand', keywords: ['stop', 'highfive'] },
      { char: '🖖', name: 'vulcan salute', keywords: ['spock', 'star-trek'] },
      { char: '👌', name: 'OK hand', keywords: ['ok', 'perfect'] },
      { char: '🤌', name: 'pinched fingers', keywords: ['italian', 'gesture'] },
      { char: '🤏', name: 'pinching hand', keywords: ['small', 'pinch'] },
      { char: '✌️', name: 'victory hand', keywords: ['peace', 'victory'] },
      { char: '🤞', name: 'crossed fingers', keywords: ['luck', 'cross'] },
      { char: '🤟', name: 'love-you gesture', keywords: ['love'] },
      { char: '🤘', name: 'sign of the horns', keywords: ['rock', 'metal'] },
      { char: '🤙', name: 'call me hand', keywords: ['call'] },
      { char: '👈', name: 'backhand index pointing left', keywords: ['point', 'left'] },
      { char: '👉', name: 'backhand index pointing right', keywords: ['point', 'right'] },
      { char: '👆', name: 'backhand index pointing up', keywords: ['point', 'up'] },
      { char: '🖕', name: 'middle finger', keywords: ['rude'] },
      { char: '👇', name: 'backhand index pointing down', keywords: ['point', 'down'] },
      { char: '☝️', name: 'index pointing up', keywords: ['point'] },
      { char: '👍', name: 'thumbs up', keywords: ['like', 'good', 'yes'] },
      { char: '👎', name: 'thumbs down', keywords: ['dislike', 'bad', 'no'] },
      { char: '✊', name: 'raised fist', keywords: ['fist', 'power'] },
      { char: '👊', name: 'oncoming fist', keywords: ['punch'] },
      { char: '🤛', name: 'left-facing fist', keywords: ['fist'] },
      { char: '🤜', name: 'right-facing fist', keywords: ['fist'] },
      { char: '👏', name: 'clapping hands', keywords: ['clap', 'applaud'] },
      { char: '🙌', name: 'raising hands', keywords: ['celebrate', 'hooray'] },
      { char: '👐', name: 'open hands', keywords: ['open'] },
      { char: '🤲', name: 'palms up together', keywords: ['prayer'] },
      { char: '🤝', name: 'handshake', keywords: ['shake', 'agreement'] },
      { char: '🙏', name: 'folded hands', keywords: ['please', 'thankyou', 'pray'] },
      { char: '✍️', name: 'writing hand', keywords: ['write'] },
      { char: '💅', name: 'nail polish', keywords: ['nail', 'fancy'] },
      { char: '🤳', name: 'selfie', keywords: ['camera', 'selfie'] },
      { char: '💪', name: 'flexed biceps', keywords: ['strong', 'muscle'] },
      { char: '🦾', name: 'mechanical arm', keywords: ['robot'] },
      { char: '🦿', name: 'mechanical leg', keywords: ['robot'] },
      { char: '🦵', name: 'leg', keywords: ['leg'] },
      { char: '🦶', name: 'foot', keywords: ['foot'] },
      { char: '👂', name: 'ear', keywords: ['hear'] },
      { char: '🦻', name: 'ear with hearing aid', keywords: ['hearing'] },
      { char: '👃', name: 'nose', keywords: ['smell'] },
      { char: '🧠', name: 'brain', keywords: ['mind', 'smart'] },
      { char: '🫀', name: 'anatomical heart', keywords: ['heart'] },
      { char: '🫁', name: 'lungs', keywords: ['breath'] },
      { char: '🦷', name: 'tooth', keywords: ['dentist'] },
      { char: '🦴', name: 'bone', keywords: ['skeleton'] },
      { char: '👀', name: 'eyes', keywords: ['look', 'see'] },
      { char: '👁️', name: 'eye', keywords: ['look'] },
      { char: '👅', name: 'tongue', keywords: ['taste'] },
      { char: '👄', name: 'mouth', keywords: ['lips'] },
      { char: '💋', name: 'kiss mark', keywords: ['kiss', 'love'] },
      { char: '🩸', name: 'drop of blood', keywords: ['blood'] },
      { char: '❤️', name: 'red heart', keywords: ['love', 'heart'] },
      { char: '🧡', name: 'orange heart', keywords: ['love', 'heart'] },
      { char: '💛', name: 'yellow heart', keywords: ['love', 'heart'] },
      { char: '💚', name: 'green heart', keywords: ['love', 'heart'] },
      { char: '💙', name: 'blue heart', keywords: ['love', 'heart'] },
      { char: '💜', name: 'purple heart', keywords: ['love', 'heart'] },
      { char: '🖤', name: 'black heart', keywords: ['love', 'heart'] },
      { char: '🤍', name: 'white heart', keywords: ['love', 'heart'] },
      { char: '🤎', name: 'brown heart', keywords: ['love', 'heart'] },
      { char: '💔', name: 'broken heart', keywords: ['sad', 'break'] },
      { char: '❤️‍🔥', name: 'heart on fire', keywords: ['love', 'passion'] },
      { char: '❤️‍🩹', name: 'mending heart', keywords: ['heal'] },
      { char: '💖', name: 'sparkling heart', keywords: ['love'] },
      { char: '💗', name: 'growing heart', keywords: ['love'] },
      { char: '💓', name: 'beating heart', keywords: ['love'] },
      { char: '💞', name: 'revolving hearts', keywords: ['love'] },
      { char: '💕', name: 'two hearts', keywords: ['love'] },
      { char: '💟', name: 'heart decoration', keywords: ['love'] },
      { char: '❣', name: 'heavy heart exclamation', keywords: ['love'] },
      { char: '💝', name: 'heart with ribbon', keywords: ['love', 'gift'] }
    ]
  },
  {
    id: 'animals',
    name: 'Animals & Nature',
    icon: '🐶',
    emojis: [
      { char: '🐶', name: 'dog face', keywords: ['dog', 'pup', 'pet'] },
      { char: '🐱', name: 'cat face', keywords: ['cat', 'kitten', 'pet'] },
      { char: '🐭', name: 'mouse face', keywords: ['mouse', 'pet'] },
      { char: '🐹', name: 'hamster face', keywords: ['hamster', 'pet'] },
      { char: '🐰', name: 'rabbit face', keywords: ['rabbit', 'bunny'] },
      { char: '🦊', name: 'fox face', keywords: ['fox'] },
      { char: '🐻', name: 'bear face', keywords: ['bear'] },
      { char: '🐼', name: 'panda face', keywords: ['panda'] },
      { char: '🐨', name: 'koala face', keywords: ['koala'] },
      { char: '🐯', name: 'tiger face', keywords: ['tiger'] },
      { char: '🦁', name: 'lion face', keywords: ['lion'] },
      { char: '🐮', name: 'cow face', keywords: ['cow'] },
      { char: '🐷', name: 'pig face', keywords: ['pig'] },
      { char: '🐸', name: 'frog face', keywords: ['frog'] },
      { char: '🐵', name: 'monkey face', keywords: ['monkey'] },
      { char: '🐔', name: 'chicken', keywords: ['chicken'] },
      { char: '🐧', name: 'penguin', keywords: ['penguin'] },
      { char: '🐦', name: 'bird', keywords: ['bird'] },
      { char: '🐤', name: 'baby chick', keywords: ['chick'] },
      { char: '🦆', name: 'duck', keywords: ['duck'] },
      { char: '🦅', name: 'eagle', keywords: ['eagle'] },
      { char: '🦉', name: 'owl', keywords: ['owl'] },
      { char: '🦇', name: 'bat', keywords: ['bat'] },
      { char: '🐺', name: 'wolf', keywords: ['wolf'] },
      { char: '🦄', name: 'unicorn', keywords: ['unicorn', 'magic'] },
      { char: '🐝', name: 'honeybee', keywords: ['bee', 'bug'] },
      { char: '🐛', name: 'bug', keywords: ['caterpillar', 'bug'] },
      { char: '🦋', name: 'butterfly', keywords: ['butterfly', 'bug'] },
      { char: '🐌', name: 'snail', keywords: ['snail'] },
      { char: '🐞', name: 'lady beetle', keywords: ['ladybug'] },
      { char: '🐙', name: 'octopus', keywords: ['octopus', 'ocean'] },
      { char: '🐠', name: 'tropical fish', keywords: ['fish'] },
      { char: '🐟', name: 'fish', keywords: ['fish'] },
      { char: '🐬', name: 'dolphin', keywords: ['dolphin', 'ocean'] },
      { char: '🐳', name: 'spouting whale', keywords: ['whale', 'ocean'] },
      { char: '🦈', name: 'shark', keywords: ['shark', 'ocean'] },
      { char: '🐊', name: 'crocodile', keywords: ['crocodile'] },
      { char: '🦖', name: 't-rex', keywords: ['dinosaur'] },
      { char: '🌴', name: 'palm tree', keywords: ['palm', 'tree', 'tropical'] },
      { char: '🌵', name: 'cactus', keywords: ['cactus', 'desert'] },
      { char: '🍁', name: 'maple leaf', keywords: ['maple', 'leaf', 'autumn'] },
      { char: '🌸', name: 'cherry blossom', keywords: ['flower', 'sakura'] },
      { char: '🌹', name: 'rose', keywords: ['flower', 'rose'] },
      { char: '🌻', name: 'sunflower', keywords: ['flower', 'sunflower'] },
      { char: '🍀', name: 'four leaf clover', keywords: ['clover', 'luck'] },
      { char: '🍄', name: 'mushroom', keywords: ['mushroom'] },
      { char: '🔥', name: 'fire', keywords: ['fire', 'hot', 'lit'] },
      { char: '💧', name: 'droplet', keywords: ['water', 'drop'] },
      { char: '⚡', name: 'high voltage', keywords: ['lightning', 'thunder', 'power'] },
      { char: '🌈', name: 'rainbow', keywords: ['rainbow', 'color'] },
      { char: '⭐', name: 'star', keywords: ['star', 'shine'] },
      { char: '✨', name: 'sparkles', keywords: ['sparkle', 'magic', 'shiny'] }
    ]
  },
  {
    id: 'food',
    name: 'Food & Drink',
    icon: '🍏',
    emojis: [
      { char: '🍎', name: 'red apple', keywords: ['apple', 'fruit'] },
      { char: '🍌', name: 'banana', keywords: ['banana', 'fruit'] },
      { char: '🍉', name: 'watermelon', keywords: ['watermelon', 'fruit'] },
      { char: '🍇', name: 'grapes', keywords: ['grapes', 'fruit'] },
      { char: '🍓', name: 'strawberry', keywords: ['strawberry', 'fruit'] },
      { char: '🍒', name: 'cherries', keywords: ['cherries', 'fruit'] },
      { char: '🍍', name: 'pineapple', keywords: ['pineapple', 'fruit'] },
      { char: '🥥', name: 'coconut', keywords: ['coconut', 'fruit'] },
      { char: '🥝', name: 'kiwi fruit', keywords: ['kiwi', 'fruit'] },
      { char: '🍅', name: 'tomato', keywords: ['tomato', 'vegetable'] },
      { char: '🥑', name: 'avocado', keywords: ['avocado'] },
      { char: '🥦', name: 'broccoli', keywords: ['broccoli', 'vegetable'] },
      { char: '🍟', name: 'french fries', keywords: ['fries', 'fastfood'] },
      { char: '🍕', name: 'pizza', keywords: ['pizza', 'fastfood', 'cheese'] },
      { char: '🍔', name: 'hamburger', keywords: ['burger', 'fastfood', 'meat'] },
      { char: '🌭', name: 'hot dog', keywords: ['hotdog', 'fastfood'] },
      { char: '🥪', name: 'sandwich', keywords: ['sandwich'] },
      { char: '🌮', name: 'taco', keywords: ['taco', 'mexican'] },
      { char: '🍿', name: 'popcorn', keywords: ['popcorn', 'snack'] },
      { char: '🍩', name: 'doughnut', keywords: ['donut', 'sweet'] },
      { char: '🍪', name: 'cookie', keywords: ['cookie', 'sweet'] },
      { char: '🎂', name: 'birthday cake', keywords: ['cake', 'birthday', 'sweet'] },
      { char: '🍰', name: 'shortcake', keywords: ['cake', 'sweet'] },
      { char: '🧁', name: 'cupcake', keywords: ['cupcake', 'sweet'] },
      { char: '🍫', name: 'chocolate bar', keywords: ['chocolate', 'sweet'] },
      { char: '🍬', name: 'candy', keywords: ['candy', 'sweet'] },
      { char: '🍭', name: 'lollipop', keywords: ['lollipop', 'sweet'] },
      { char: '🍦', name: 'soft ice cream', keywords: ['icecream', 'sweet'] },
      { char: '🍺', name: 'beer mug', keywords: ['beer', 'drink', 'alcohol'] },
      { char: '🍻', name: 'clinking beer mugs', keywords: ['beers', 'drink', 'alcohol', 'cheers'] },
      { char: '🍷', name: 'wine glass', keywords: ['wine', 'drink'] },
      { char: '🍸', name: 'cocktail glass', keywords: ['cocktail', 'drink'] },
      { char: '🍹', name: 'tropical drink', keywords: ['cocktail', 'drink'] },
      { char: '☕', name: 'hot beverage', keywords: ['coffee', 'tea', 'cafe'] },
      { char: '🥤', name: 'cup with straw', keywords: ['soda', 'drink'] }
    ]
  },
  {
    id: 'activity',
    name: 'Activity & Sports',
    icon: '⚽',
    emojis: [
      { char: '⚽', name: 'soccer ball', keywords: ['soccer', 'football', 'sports'] },
      { char: '🏀', name: 'basketball', keywords: ['basketball', 'sports'] },
      { char: '🏈', name: 'american football', keywords: ['football', 'sports'] },
      { char: '⚾', name: 'baseball', keywords: ['baseball', 'sports'] },
      { char: '🎾', name: 'tennis', keywords: ['tennis', 'sports'] },
      { char: '🏐', name: 'volleyball', keywords: ['volleyball', 'sports'] },
      { char: '🎱', name: 'pool 8 ball', keywords: ['billiards', 'pool', 'game'] },
      { char: '🎮', name: 'video game', keywords: ['controller', 'game', 'gaming', 'play'] },
      { char: '🕹️', name: 'joystick', keywords: ['joystick', 'game'] },
      { char: '🎲', name: 'game die', keywords: ['dice', 'game'] },
      { char: '♟️', name: 'chess pawn', keywords: ['chess', 'game'] },
      { char: '🎨', name: 'artist palette', keywords: ['paint', 'art'] },
      { char: '🎬', name: 'clapper board', keywords: ['movie', 'film'] },
      { char: '🎤', name: 'microphone', keywords: ['sing', 'karaoke', 'music'] },
      { char: '🎧', name: 'headphones', keywords: ['music', 'audio'] },
      { char: '🎸', name: 'guitar', keywords: ['music', 'guitar'] },
      { char: '🎹', name: 'musical keyboard', keywords: ['music', 'piano'] },
      { char: '🏆', name: 'trophy', keywords: ['winner', 'gold', 'prize'] },
      { char: '🥇', name: '1st place medal', keywords: ['winner', 'gold'] },
      { char: '🎟️', name: 'admission tickets', keywords: ['ticket', 'show'] },
      { char: '🎈', name: 'balloon', keywords: ['party', 'balloon'] },
      { char: '🎉', name: 'partying face', keywords: ['party', 'popper', 'celebrate'] },
      { char: '🎊', name: 'confetti ball', keywords: ['party', 'celebrate'] }
    ]
  },
  {
    id: 'travel',
    name: 'Travel & Places',
    icon: '🚗',
    emojis: [
      { char: '🚗', name: 'automobile', keywords: ['car', 'drive'] },
      { char: '🚀', name: 'rocket', keywords: ['rocket', 'space', 'launch'] },
      { char: '✈️', name: 'airplane', keywords: ['flight', 'plane'] },
      { char: '🚁', name: 'helicopter', keywords: ['chopper'] },
      { char: '🚢', name: 'ship', keywords: ['boat', 'cruise'] },
      { char: '🛸', name: 'ufo', keywords: ['alien', 'ufo'] },
      { char: '⚓', name: 'anchor', keywords: ['boat', 'sea'] },
      { char: '⛰️', name: 'mountain', keywords: ['mountain'] },
      { char: '🌋', name: 'volcano', keywords: ['volcano'] },
      { char: '⛺', name: 'tent', keywords: ['camping', 'tent'] },
      { char: '🏖️', name: 'beach with umbrella', keywords: ['beach', 'summer', 'vacation'] },
      { char: '🗽', name: 'statue of liberty', keywords: ['ny', 'america'] },
      { char: '🏰', name: 'castle', keywords: ['castle', 'disney'] },
      { char: '🌍', name: 'globe showing Europe-Africa', keywords: ['earth', 'globe', 'world'] },
      { char: '🗺️', name: 'world map', keywords: ['map', 'travel'] }
    ]
  },
  {
    id: 'objects',
    name: 'Objects & Symbols',
    icon: '💡',
    emojis: [
      { char: '💡', name: 'light bulb', keywords: ['idea', 'light'] },
      { char: '💻', name: 'laptop', keywords: ['computer', 'tech'] },
      { char: '📱', name: 'mobile phone', keywords: ['phone', 'mobile'] },
      { char: '📷', name: 'camera', keywords: ['camera', 'photo'] },
      { char: '📺', name: 'television', keywords: ['tv'] },
      { char: '💰', name: 'money bag', keywords: ['cash', 'money', 'rich'] },
      { char: '🎁', name: 'wrapped gift', keywords: ['gift', 'present', 'birthday'] },
      { char: '✉️', name: 'envelope', keywords: ['mail', 'letter'] },
      { char: '🔑', name: 'key', keywords: ['key', 'lock'] },
      { char: '🔒', name: 'locked', keywords: ['lock', 'security'] },
      { char: '🔓', name: 'unlocked', keywords: ['lock', 'security'] },
      { char: '🔨', name: 'hammer', keywords: ['tool', 'build'] },
      { char: '⚙️', name: 'gear', keywords: ['settings', 'gear'] },
      { char: '🛡️', name: 'shield', keywords: ['defense', 'security'] },
      { char: '💣', name: 'bomb', keywords: ['explode'] },
      { char: '🔫', name: 'water pistol', keywords: ['gun', 'pistol'] },
      { char: '🔮', name: 'crystal ball', keywords: ['magic', 'future'] },
      { char: '❤️', name: 'red heart', keywords: ['love', 'heart'] },
      { char: '⭐', name: 'star', keywords: ['star'] },
      { char: '✨', name: 'sparkles', keywords: ['sparkle'] },
      { char: '⚠️', name: 'warning', keywords: ['warning', 'danger'] },
      { char: '✅', name: 'check mark button', keywords: ['check', 'done'] },
      { char: '❌', name: 'cross mark', keywords: ['cross', 'delete'] }
    ]
  }
];
